import { Heading, Text, Box } from '@medely/ui-kit';
import React from 'react';

export const W2CompensationModalInfo = () => {
  return (
    <>
      <Heading size="xs">This is a W2 travel assignment</Heading>
      <Box py={2}>
        <Text size="l" textAlign="justify">
          Medely has partnered with Frontline Health to offer a W2 option to Medely professionals.
        </Text>
      </Box>
      <Heading size="xs">Pay</Heading>
      <Box py={2}>
        <Text size="l" textAlign="justify">
          Assignments are paid via weekly automatic direct deposits to your bank account.
        </Text>
        <Text size="l" textAlign="justify">
          Earnings are automatically calculated on a weekly cycle, which normally begin at 12am PT
          on Sunday and end at 11:59pm PT the following Saturday.
        </Text>
      </Box>
      <Heading size="xs">Taxable income</Heading>
      <Box py={2}>
        <Text size="l" textAlign="justify">
          Your taxable income is how much in wages you’ll make for working all Contracted Hours
          every week.
        </Text>
        <Text size="l" textAlign="justify">
          This rate is based on your Contracted Hours and may change as you work extra hours, shifts
          with different rates, and more.
        </Text>
      </Box>
      <Heading size="xs">Tax-free stipend</Heading>
      <Box py={2}>
        <Text size="l" textAlign="justify">
          Stipends are calculated to reimburse your lodging, meals, and incidentals while working
          away from home. You’ll receive these Stipends as a lump sum each pay period. Your
          eligibility for a tax-free stipend is based on IRS guidelines and while we’re here to
          help, we’d suggest you talk to a tax professional if you have any questions about your
          specific situation.
        </Text>
      </Box>
    </>
  );
};
